import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Content from "../../../Layout/Content";
import { Spin, Input, Button, Grid, Message, Modal, Switch } from "@arco-design/web-react";
import { useAuth0 } from '@auth0/auth0-react';
import { FetchApi, PostApi, OverwriteApi, DeleteApi } from "../../../Api/AuthenticatedApi";
import SummaryCard from "../../../Layout/SummaryCard";
import { IconDelete as DeleteIcon } from "@arco-design/web-react/icon";

import EmailComposer from "../../../Editor/EmailComposer/EmailComposer";
import { confirmIfLive } from "../../../utils/confirmIfLive";
import SimpleBreadcrumbs from "../../../Components/Breadcrumbs/SimpleBreadcrumbs";
import RecordNotFound from "../../../Components/RecordNotFound";

const { Row, Col } = Grid;


function truncateText(text, maxLength) {
    if (text.length > maxLength) {
        return text.substring(0, maxLength); // Truncate the text
    }
    return text; // If the text is already shorter or equal to maxLength, return it unchanged
}


// const SAVE_BUTTON_TEXT = "Save"
// const CANCEL_BUTTON_TEXT = "Cancel"
// const EDITOR_MODE_EDIT = "edit";
// const EDITOR_MODE_CANCEL = "cancel";


const DELETE_BUTTON_TEXT = "Delete"


export default function BroadcastMailVariantEditor() {
    const { broadcastId, mailVariantId } = useParams();

    // const {campaignId} = useParams();
    const [broadcastRecord, setBroadcastRecord] = useState({});

    const [record, setRecord] = useState({});
    const [loading, setLoading] = useState(false);
    const [loadFailed, setLoadFailed] = useState(false);
    // Saving reseeds the composer, which remounts the heavy Easy Email editor.
    // Cover that visible gap with a spinner overlay.
    const [saving, setSaving] = useState(false);

    // const [value, setValue] = useState("0")

    // ui controls
    // const [saveOrCancelText, setSaveOrCancelText] = useState(SAVE_BUTTON_TEXT);
    // const [formSavable, setFormSavable] = useState(false);

    // controlled variables for the record
    const [shouldRun, setShouldRun] = useState(false)
    // const [broadcastId, setBroadcastId] = useState("helpme");
    const [variantName, setVariantName] = useState("");
    // const [variantTopic, setVariantTopic] = useState("");

    // we manage the editor from here so that we can keep state as we flip betwen preview and editor
    // The email content (subject/html/text/design) is owned by the shared
    // <EmailComposer>; we read it at save time via composerRef.getContent().
    // composerSeed + seedKey (re)seed the composer when a record loads or the user
    // cancels an edit.
    const composerRef = useRef(null);
    const [composerSeed, setComposerSeed] = useState({});
    const [seedKey, setSeedKey] = useState(0);

    const [templateModalVisible, setTemplateModalVisible] = useState(false);
    const [templateName, setTemplateName] = useState("");
    const [allTemplates, setAllTemplates] = useState([]);




    // const [confirmEmailUrl, setConfirmEmailUrl] = useState("");
    // const [senderEmail, setSenderEmail] = useState("");




    const deleteMailVariant = (event) => {
        if (mailVariantId === "new") return;
        Modal.confirm({
            title: "Delete this email variant?",
            content: "This can't be undone.",
            okButtonProps: { status: "danger" },
            okText: "Delete",
            onOk: () => {
                let url = "/api/broadcasts/" + broadcastId + "/mailvariants/" + mailVariantId
                DeleteApi(getAccessTokenSilently, url, (data) => {
                    setLoading(false);
                    Message.success("Email variant deleted");
                    history("/broadcasts/" + broadcastId + "/view")
                }, (response) => {
                    setLoading(false);
                    history("/login");
                }, (response) => {
                    setLoading(false);
                    Message.error("Failed to delete email variant");
                })
            },
        });

    }



    // const [campaignName, setCampaignName] = useState("");


    // controlled variables for non-record
    // const [suggestionTopic, setSuggestionTopic] = useState("");

    const { getAccessTokenSilently } = useAuth0();
    const history = useNavigate();

    useEffect(() => {
        if (mailVariantId !== "new") return;
        FetchApi(getAccessTokenSilently, "/api/email-templates/",
            (data) => setAllTemplates(data || []),
            () => history("/login"),
            () => {});
    }, [mailVariantId, getAccessTokenSilently, history]);

    // const editOrCancel = (event) => {
    //     if (editOrCancelText === SAVE_BUTTON_TEXT) {
    //         setEditOrCancelText(CANCEL_BUTTON_TEXT);
    //         setFormSavable(true);
    //     } else {
    //         setEditOrCancelText(EDIT_BUTTON_TEXT);
    //         setFromRecord(record);  // reset values
    //         setFormSavable(false);
    //     }
    // }

    // const safeSetString = (setter, item) => {
    //     if (!!item) {
    //         setter(item)
    //     } else {
    //         setter("")
    //     }
    // }

    const setFromRecord = (r) => {
        setVariantName("" + r.name)
        setShouldRun(r.should_run)
        // Hand the loaded content to the composer and bump seedKey so it reseeds
        // (also the reset path when the user cancels an edit).
        setComposerSeed({
            subject: r.mail_subject_template,
            html: r.mail_html_template,
            text: r.mail_text_template,
            design: r.editor_design,
        })
        setSeedKey((k) => k + 1)
    }

    // Pull the final content (compiled HTML + Easy Email design) out of the shared
    // composer at save time and add the broadcast-specific fields.
    const buildPayload = () => {
        const content = composerRef.current ? composerRef.current.getContent() : {};
        return {
            name: variantName,
            should_run: shouldRun,
            ...content,
        };
    }

    const handleSaveAsTemplate = () => {
        const name = templateName.trim();
        if (!name) return;
        const p = buildPayload();
        PostApi(getAccessTokenSilently, "/api/email-templates/",
            () => {
                setTemplateModalVisible(false);
                setTemplateName("");
                Message.success("Saved as template");
            },
            () => history("/login"),
            () => Message.error("Failed to save template"),
            {
                name,
                mail_subject_template: p.mail_subject_template,
                mail_html_template: p.mail_html_template,
                mail_text_template: p.mail_text_template,
                editor_design: p.editor_design,
            },
        );
    }

    const saveMailVariant = async () => {
        const ok = await confirmIfLive({ live: isLive, title: "This email is live", content: liveReason });
        if (!ok) return;
        setSaving(true);
        const payload = buildPayload();
        if (mailVariantId === "new") {
            createVariant(payload);
        } else {
            saveVariant(payload);
        }
    }

    useEffect(() => {
        (async () => {
            let url = "/api/broadcasts/" + broadcastId
            FetchApi(getAccessTokenSilently, url,
                (data) => {
                    setLoading(false);
                    setBroadcastRecord(data);
                    // setFromRecord(data);
                },
                (response) => {
                    setLoading(false);
                    history("/login");
                }, (response) => {
                    setLoading(false);
                    setLoadFailed(true);
                })
        })();
    }, [broadcastId, setBroadcastRecord, setLoading, history, getAccessTokenSilently])

    useEffect(() => {
        if (mailVariantId !== 'new') {
            (async () => {
                let url = "/api/broadcasts/" + broadcastId + "/mailvariants/" + mailVariantId
                FetchApi(getAccessTokenSilently, url,
                    (data) => {
                        setLoading(false);
                        setRecord(data);
                        setFromRecord(data);
                    },
                    (response) => {
                        setLoading(false);
                        history("/login");
                    }, (response) => {
                        setLoading(false);
                        setLoadFailed(true);
                    })
            })();
        }
    }, [broadcastId, mailVariantId, setRecord, setLoading, history, getAccessTokenSilently])

    if (loadFailed) {
        return <RecordNotFound what="email" backTo={`/broadcasts/${broadcastId}/view`} backLabel="Back to the broadcast" />;
    }

    if (loading) {
        return (
            <Content>
                <Spin />
            </Content>
        );
    }

    function createVariant(data) {
        (async () => {
            let url = "/api/broadcasts/" + broadcastId + "/mailvariants/";
            PostApi(getAccessTokenSilently, url,
                (data) => {
                    setLoading(false);
                    setRecord(data);
                    setFromRecord(data);
                    setSaving(false);
                    Message.success("Email variant created");
                    // Switch from the "new" URL to the created variant so the next
                    // save UPDATES it instead of creating yet another row.
                    if (data && data.id) {
                        history("/broadcasts/" + broadcastId + "/email/" + data.id);
                    }
                },
                (response) => {
                    setLoading(false);
                    setSaving(false);
                    history("/login");
                }, (response) => {
                    setLoading(false);
                    setSaving(false);
                    Message.error("Failed to create email variant");
                }, data);
        })();
    }

    function saveVariant(data) {
        (async () => {
            let url = "/api/broadcasts/" + broadcastId + "/mailvariants/" + mailVariantId;
            // Backend registers this path as PUT (HandlePutMailVariant), not PATCH.
            OverwriteApi(getAccessTokenSilently, url,
                (data) => {
                    setLoading(false);
                    setRecord(data);
                    setFromRecord(data);
                    setSaving(false);
                    Message.success("Email variant saved");
                },
                (response) => {
                    setLoading(false);
                    setSaving(false);
                    history("/login");
                }, (response) => {
                    setLoading(false);
                    setSaving(false);
                    Message.error("Failed to save email variant");
                }, data);
        })();
    }

    const sent = (record && record.sent) || 0;
    const opens = (record && record.opens) || 0;
    const isLive = sent > 0 || opens > 0;
    const liveReason = `This email has been sent ${sent.toLocaleString()} time${sent === 1 ? "" : "s"}. Saving edits an email that's already gone out.`;

    return (
        <Content>
            {/* <div
                style={{
                    height: "200px",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    filter: "contrast(75%)",
                    backgroundImage: "url(/img/wallpaper.jpeg)",
                }}
            /> */}


            <SimpleBreadcrumbs
                elements={
                    [
                        { name: 'Broadcasts', path: '/broadcasts' },
                        { name: broadcastRecord.name, path: `/broadcasts/${broadcastRecord.id}/edit` },
                        { name: "email:" + ((record && record.id) ? (record.mail_subject_template ? truncateText(record.mail_subject_template, 10) : "no subject") : "new") },
                    ]
                }
            />

            <div>

                <SummaryCard title={"Email Version"}>
                    <Row gutter={16}>
                        <Col span={24} style={{ marginBottom: 12 }}>
                            <Button.Group>
                                {/* <Button
                                    disabled={editorMode === EDITOR_MODE_CANCEL}
                                    color="primary"
                                    onClick={() => setEditorMode(EDITOR_MODE_CANCEL)}
                                >
                                    Preview
                                </Button>
                                <Button
                                    disabled={editorMode === EDITOR_MODE_EDIT}
                                    color="primary"
                                    onClick={() => setEditorMode(EDITOR_MODE_EDIT)}
                                >
                                    Edit
                                </Button>
                                <Button
                                    disabled={editorMode === EDITOR_MODE_EDIT}
                                    color="primary"
                                    onClick={deleteMailVariant}
                                >
                                    Delete
                                </Button> */}
                                <Button type="primary" onClick={saveMailVariant}>Save</Button>
                                <Button onClick={() => setFromRecord(record)}>Discard</Button>
                                <Button onClick={() => setTemplateModalVisible(true)}>Save as template</Button>
                                <Button icon={<DeleteIcon />} onClick={deleteMailVariant} disabled={mailVariantId === "new"}>
                                    {DELETE_BUTTON_TEXT}
                                </Button>

                            </Button.Group>
                        </Col>

                        <Col span={24} style={{ marginBottom: 16 }}>
                            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start", gap: 20 }}>
                                <div style={{ flex: "1 1 260px", minWidth: 220 }}>
                                    <div style={{ fontSize: 12, color: "var(--color-text-3)", marginBottom: 4 }}>Email name</div>
                                    <Input value={variantName} placeholder="e.g. Version A" onChange={setVariantName} />
                                </div>
                                <div>
                                    <div style={{ fontSize: 12, color: "var(--color-text-3)", marginBottom: 4 }}>Status</div>
                                    <div style={{ display: "flex", alignItems: "center", gap: 8, height: 32 }}>
                                        <Switch checked={shouldRun} onChange={setShouldRun} />
                                        <span style={{ color: "var(--color-text-2)" }}>{shouldRun ? "Active" : "Paused"}</span>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col span={24}>
                            <Spin loading={saving} tip="Saving…" style={{ display: "block", width: "100%" }}>
                                <EmailComposer
                                    ref={composerRef}
                                    initial={composerSeed}
                                    seedKey={seedKey}
                                    disabled={false}
                                    templates={mailVariantId === "new" ? allTemplates : undefined}
                                    enablePersonalize
                                />
                            </Spin>
                        </Col>


                    </Row>

                </SummaryCard>

            </div>

            <Modal
                title="Save as template"
                visible={templateModalVisible}
                onOk={handleSaveAsTemplate}
                onCancel={() => setTemplateModalVisible(false)}
                okText="Save template"
                simple
            >
                <p style={{ color: "var(--color-text-3)", marginTop: 0 }}>
                    Saves this email's design as a reusable template.
                </p>
                <Input
                    placeholder="Template name (e.g. Monthly newsletter)"
                    value={templateName}
                    onChange={setTemplateName}
                    onPressEnter={handleSaveAsTemplate}
                />
            </Modal>
        </Content>
    );
}
